<template>
  <div id="main-body">
    <div id="search-field" :class="{ breakdownView: showInmateBreakdown }">
      <div id="search-inputs">
        <div class="text-entry">
          <label class="entry-title" v-show="FirstName != ''">
            First Name
          </label>
          <label class="entry-title" v-show="FirstName == ''">
            <br />
          </label>
          <input
            type="text"
            v-model="FirstName"
            placeholder="First Name"
            v-on:keyup.enter="filterInmateSearch"
          />
        </div>

        <div class="text-entry">
          <label class="entry-title" v-show="LastName != ''"> Last Name </label>
          <label class="entry-title" v-show="LastName == ''">
            <br />
          </label>
          <input
            type="text"
            v-model="LastName"
            placeholder="Last Name"
            v-on:keyup.enter="filterInmateSearch"
          />
        </div>

        <div class="text-entry">
          <label class="entry-title" v-show="Age != ''"> Age </label>
          <label class="entry-title" v-show="Age == ''">
            <br />
          </label>
          <input
            type="text"
            v-model="Age"
            placeholder="Age"
            v-on:keyup.enter="filterInmateSearch"
          />
        </div>

        <div class="select-box">
          <label class="entry-title" v-show="InmateStatus != ''">
            Status
          </label>
          <label class="entry-title" v-show="InmateStatus == ''">
            <br />
          </label>
          <select v-model="InmateStatus" class="select-list">
            <option value="" selected>Select a Status</option>
            <option
              v-for="status in inmateStatuses"
              :value="status"
              :key="status"
            >
              {{ status }}
            </option>
          </select>
          <!-- <option value="CM">CM - Custody Mixed</option>
            <option value="CO">CO - Custody Other</option>
            <option value="CP">CP - Custody Pre-Trial</option>
            <option value="CS">CS - Custody Sentenced</option> -->
        </div>
        <div class="select-box">
          <label class="entry-title" v-show="Race != ''"> Race </label>
          <label class="entry-title" v-show="Race == ''">
            <br />
          </label>
          <!-- <input type="text" v-model="Race" placeholder="Race"> -->
          <!-- <select v-model="Race" class="select-list">
            <option value="" selected>Select a Race</option>
            <option value="Asian">Asian</option>
            <option value="Arabic">Arabic Origin</option>
            <option value="Black">Black</option>
            <option value="Hispanic">Hispanic</option>
            <option value="American Indian">American Indian</option>
            <option value="Pacific Islander">
              Pacific Islander / Hawaiian
            </option>
            <option value="TwoOrMore">
              Two or more Races (non Hispanic origin)
            </option>
            <option value="Unknown">Unkown</option>
            <option value="White">White</option>
          </select> -->

          <select v-model="Race" class="select-list">
            <option value="" selected>Select a Race</option>
            <option v-for="race in inmateRaces" :value="race" :key="race">
              {{ race }}
            </option>
          </select>
        </div>
        <div class="select-box">
          <label class="entry-title" v-show="Gender != ''"> Gender </label>
          <label class="entry-title" v-show="Gender == ''">
            <br />
          </label>
          <!-- <input type="text" v-model="Gender" placeholder="Gender"> -->
          <select v-model="Gender" class="select-list">
            <option value="" selected>Select a Gender</option>
            <option
              v-for="gender in inmateGenders"
              :value="gender"
              :key="gender"
            >
              {{ gender }}
            </option>
          </select>
        </div>
      </div>
      <div id="radio-current-historic">
        <input
          type="radio"
          id="radio-is-current"
          name="CurrentOrHistoric"
          value="current"
          checked
        />
        <label for="radio-is-current">Current Inmates</label>
        <br />
        <input
          type="radio"
          id="radio-is-historic"
          name="CurrentOrHistoric"
          value="historic"
          v-show="AllowHistoricData"
        />

        <!-- <img
          class="small-loader"
          v-show="AllowHistoricData && !historicData"
          src="../../public/Loading.gif"
        /> -->
        <label for="radio-is-historic" v-if="AllowHistoricData"
          >Historic Inmates
        </label>
        <!-- <label
          class="unfinished"
          for="radio-is-historic"
          v-if="AllowHistoricData && !historicData"
          >Historic Inmates
        </label> -->
      </div>
      <!-- <button @click="displayDevOptions = !displayDevOptions">Display Dev</button> -->
      <div v-if="!showLoadingButton">
        <button
          @click="clearSearch"
          :class="{ btnDisabled: !showInmateResults && !showInmateBreakdown }"
        >
          Clear Results
        </button>
        <button v-if="!searchHasData" @click="filterInmateSearch">
          Show All
        </button>
        <button v-else @click="filterInmateSearch">Search</button>
      </div>
      <div v-else>
        <button>Loading Records...</button>
      </div>
    </div>

    <!-- This entire div can be removed and is just for dev testing (also remove the displayDevOptions button) -->
    <div class="Debugging" v-if="displayDevOptions">
      First Name = {{ FirstName }}
      <br />
      Last Name = {{ LastName }}
      <br />
      Age = {{ Age }}
      <br />
      Status = {{ InmateStatus }}
      <br />
      Race = {{ Race }}
      <br />
      Gender = {{ Gender }}
      <br />
      SqlString:
      <br />
      {{ sqlString }}
    </div>

    <!-- <div v-show="showLoadingBar">
      <img src="../../public/Loading.gif" />
    </div> -->

    <div class="results" v-show="showInmateResults && !showInmateBreakdown">
      <div class="break-line"></div>
      RESULTS
      <div v-show="filteredInmates.length == 0" class="no-results">
        -- NONE --
      </div>
      <div v-show="filteredInmates.length > 0" class="results-count">
        -- {{ totalInmatesFound }} found --
        <br />
        Page {{ currentPage }} of {{ totalPages }}
      </div>
    </div>

    <div v-if="displayLoader" class="loader">
      <!-- <img src="../../public/Loading.gif" /> -->
      <img src="../../public/loading.a4b42243.gif" />
    </div>

    <br />
    <!-- Next and Previous Page Buttons -->
    <div
      v-if="totalPages != 1 && !showInmateBreakdown"
      class="next-prev-buttons"
    >
      <div v-if="currentPage != 1">
        <button @click="showPreviousPage">Previous Page</button>
      </div>

      <div v-if="currentPage != totalPages">
        <button @click="showNextPage">Next Page</button>
      </div>
    </div>

    <div class="inmate-full" v-show="showInmateResults && !showInmateBreakdown">
      <div
        class="inmate-image-div"
        v-for="inmate in filteredInmates"
        :key="inmate.photo"
      >
        <inmate-box :Inmate="inmate" />
      </div>
    </div>

    <br />
    <!-- Next and Previous Page Buttons -->
    <div
      v-if="totalPages != 1 && !showInmateBreakdown"
      class="next-prev-buttons"
    >
      <div v-if="currentPage != 1">
        <button @click="showPreviousPage">Previous Page</button>
      </div>

      <div v-if="currentPage != totalPages">
        <button @click="showNextPage">Next Page</button>
      </div>
    </div>

    <div
      class="inmate-breakdown"
      v-if="showInmateResults && showInmateBreakdown"
    >
      <button class="back-button" @click="returnToSearchResults">
        🡨 Go Back
      </button>
      <inmate-breakdown :Inmate="currentInmate" />
      <button class="back-button" @click="returnToSearchResults">
        🡨 Go Back
      </button>
    </div>
  </div>
</template>

<script>
import { eventBus } from "../main.js";
// import DBCommunication from "../services/DBCommunication.js";
import InmateBox from "./InmateBox.vue";
import InmateBreakdown from "./InmateBreakdown.vue";

export default {
  components: {
    InmateBox,
    InmateBreakdown,
  },
  data() {
    return {
      //Below are for the user entry fields
      FirstName: "",
      LastName: "",
      Age: "",
      InmateStatus: "",
      Race: "",
      Gender: "",
      //This keeps track of what inmate to send to InmateBreakdown.vue when clicked
      currentInmate: {},
      // sqlString: "",
      //DevOptions are depricated
      displayDevOptions: false,
      //Global booleans that tell the app which screen should be showing
      showLoadingButton: true,
      showInmateResults: false,
      showInmateBreakdown: false,
      //Objects that feed the combo-boxes, captured from the db (check created())
      inmateRaces: [],
      inmateGenders: [],
      inmateStatuses: [],
      // showLoadingBar: false, //LOADING BAR
      //Master list of all inmates received from the DB
      currentInmates: [],
      //Filtered list used when making a search
      filteredInmates: [],
      historicData: false,
      AllowHistoricData: false, //DO NOT manually change this, go to store > index.js to change
      historicInmates: [],
      //IN DEVELOPMENT -------------------------------------------------
      splitResultsIntoPages: false,
      currentPage: 1,
      totalPages: 1,
      elementsPerPage: 24,
      filteredInmatesPerPageMasterList: [],
      totalInmatesFound: 0,
      displayLoader: false,
      searchIsHistoric: false,
      //IN DEVELOPMENT -------------------------------------------------
    };
  },
  computed: {
    searchHasData() {
      return (
        this.FirstName != "" ||
        this.LastName != "" ||
        this.Age != "" ||
        this.InmateStatus != "" ||
        this.Race != "" ||
        this.Gender != ""
      );
    },
    // isSearching() {
    //   return this.showLoadingBar == true;
    // },
  },
  methods: {
    // showDevMenu(event) {
    //   if (event.code == "68") {
    //     this.displayDevOptions = !this.displayDevOptions;
    //   }
    // },
    HandleData(currentInmates) {
      //DEVELOPMENT
      // console.log("Data received by Data Organizer");
      // console.log(currentInmates);
      this.currentInmates = currentInmates;
      this.showLoadingButton = false;
    },
    verifyDataExists() {
      let currentInmates = this.$store.state.currentInmates;
      // let checkCounter = 0;
      setTimeout(() => {
        currentInmates = this.$store.state.currentInmates;
      }, 100);
      //DEVELOPMENT
      // console.log("checkCounter: " + checkCounter.toString());
      this.HandleData(currentInmates);
    },

    clearSearch() {
      this.FirstName = "";
      this.LastName = "";
      this.Age = "";
      // this.sqlString = "";
      this.InmateStatus = "";
      this.Race = "";
      this.Gender = "";

      this.showInmateResults = false;
      this.showInmateBreakdown = false;
      this.currentPage = 1;
      this.totalPages = 1;
    },

    //This is just a cover function to handle unloading and loading the results
    filterInmateSearch() {
      // if (
      //   document.getElementById("radio-is-historic").checked &&
      //   !this.historicData
      // ) {
      //   alert("Historic data is still loading, please try again shortly!");
      //   return;
      // }

      this.showInmateResults = false;

      //BELOW IS FOR EXPERIMENTAL HISTORIC FETCHING

      this.currentPage = 1;
      this.totalPages = 1;

      if (
        this.AllowHistoricData &&
        document.getElementById("radio-is-historic").checked
      ) {
        let searchTerms = {};
        let searchUsed = false;
        this.searchIsHistoric = true;
        this.filteredInmates = [];

        //Null or Empty checking, if they are either, the result must be null
        if (this.FirstName) {
          searchTerms.firstName = this.FirstName;
          searchUsed = true;
        }
        if (this.LastName) {
          searchTerms.lastName = this.LastName;
          searchUsed = true;
        }
        if (this.Age) {
          searchTerms.age = this.Age;
          searchUsed = true;
        }
        if (this.InmateStatus) {
          searchTerms.inmateStatus = this.InmateStatus;
          searchUsed = true;
        }
        if (this.Race) {
          searchTerms.race = this.Race;
          searchUsed = true;
        }
        if (this.Gender) {
          searchTerms.gender = this.Gender;
          searchUsed = true;
        }

        if (!searchUsed) {
          alert("Search terms required on a historic inmate search.");
          return;
        }
        this.displayLoader = true;

        this.$store.state.searchTerms = searchTerms;
        //Goes to App.vue
        eventBus.$emit("makehistoricsearch");

        return;
      }

      //ABOVE IS FOR EXPERIMENTAL HISTORIC FETCHING

      this.filterInmateSearchResults();
      this.showInmateBreakdown = false;
      // this.showLoadingBar = false;
      this.showInmateResults = true;
    },
    //Re-sorts the inmate list by booking date in descending order (4/14/2023 -> 1/1/2023)
    sortInmatesByLastName() {
      if (this.filteredInmates && this.filteredInmates.length > 1) {
        this.filteredInmates = this.filteredInmates.sort((a, b) =>
          a["inmateLast"] > b["inmateLast"] ? 1 : -1
        );
      }
    },

    filterInmateSearchResults(historic = false) {
      if (historic) {
        this.filteredInmates = this.historicInmates;
        this.searchIsHistoric = true;
      } else {
        this.filteredInmates = this.currentInmates;
        this.searchIsHistoric = false;
      }
      // if (document.getElementById("radio-is-current").checked) {
      //   this.filteredInmates = this.filteredInmates.filter((inmate) => {
      //     return inmate.releaseDate == null || inmate.releaseDate == "";
      //   });
      // }
      if (
        historic ||
        (this.FirstName == "" &&
          this.LastName == "" &&
          this.Age == "" &&
          this.InmateStatus == "" &&
          this.Race == "" &&
          this.Gender == "")
      ) {
        // this.showInmateBreakdown = false;
        //IN DEVELOPMENT -----------------------------------------------------------------------------

        this.sortInmatesByLastName();
        this.calculateElementsPerPage();
        return;
        //IN DEVELOPMENT -----------------------------------------------------------------------------
        // return;
      }
      //DEVELOPMENT
      // console.log("Criteria found, filtering search...");
      if (this.FirstName != "") {
        this.filteredInmates = this.filteredInmates.filter((inmate) =>
          inmate.inmateFirst
            .toLowerCase()
            .includes(this.FirstName.toLowerCase())
        );
      }
      if (this.LastName != "") {
        this.filteredInmates = this.filteredInmates.filter((inmate) =>
          inmate.inmateLast.toLowerCase().includes(this.LastName.toLowerCase())
        );
      }
      if (this.Age != "") {
        this.filteredInmates = this.filteredInmates.filter((inmate) => {
          return inmate.age == this.Age;
        });
      }
      if (this.InmateStatus != "") {
        this.filteredInmates = this.filteredInmates.filter((inmate) => {
          return (
            inmate.inmateStatus.toLowerCase() == this.InmateStatus.toLowerCase()
          );
        });
      }
      if (this.Race != "") {
        this.filteredInmates = this.filteredInmates.filter((inmate) => {
          if (inmate.race){
              return inmate.race.toLowerCase() == this.Race.toLowerCase();
          }          
        });
      }
      if (this.Gender != "") {
        this.filteredInmates = this.filteredInmates.filter((inmate) => {
           if (inmate.gender){
            return inmate.gender.toLowerCase() == this.Gender.toLowerCase();
           }        
        });
      }

      this.sortInmatesByLastName();

      //IN DEVELOPMENT -----------------------------------------------------------------------------
      this.calculateElementsPerPage();
      //IN DEVELOPMENT -----------------------------------------------------------------------------

      // this.showInmateBreakdown = false;
      //DEVELOPMENT
      // console.log("Filter complete!");
      // console.log(this.filteredInmates);
    },
    //UNDER DEVELOPMENT
    //Determines how many and what elements to display
    calculateElementsPerPage() {
      if (this.filteredInmates.length > this.elementsPerPage) {
        //Calculates the total number of pages needed
        this.totalPages = Math.ceil(
          this.filteredInmates.length / this.elementsPerPage
        );
        this.totalInmatesFound = this.filteredInmates.length;
        // this.filteredInmatesPerPageMasterList = this.filteredInmates;
        this.filteredInmates = this.filteredInmates.filter((inmate) => {
          return (
            this.filteredInmates.indexOf(inmate) >
              this.elementsPerPage * (this.currentPage - 1) - 1 &&
            this.filteredInmates.indexOf(inmate) <
              this.elementsPerPage * this.currentPage
          );
        });

        return;
      } else {
        this.totalInmatesFound = this.filteredInmates.length;
      }
    },
    showNextPage() {
      this.currentPage++;
      this.filterInmateSearchResults(this.searchIsHistoric);
      this.determineScrollHeight();
    },
    showPreviousPage() {
      this.currentPage--;
      this.filterInmateSearchResults(this.searchIsHistoric);
      this.determineScrollHeight();
    },
    returnToSearchResults() {
      this.showInmateBreakdown = false;
      this.determineScrollHeight();
    },
    determineScrollHeight() {
      setTimeout(() => {
        if (window.innerWidth >= 1336) {
          window.scrollTo(0, 310);
        } else if (window.innerWidth > 1000) {
          window.scrollTo(0, 394);
        } else if (window.innerWidth >= 720) {
          window.scrollTo(0, 372);
        } else if (window.innerWidth >= 676) {
          window.scrollTo(0, 438);
        } else if (window.innerWidth >= 456) {
          window.scrollTo(0, 524);
        } else {
          window.scrollTo(0, 850);
        }
      }, 100);
    },
    // General Utility Methods
    // not used
    modalOpen() {
      this.$nextTick(() => {
        eventBus.$emit("openModalWindow"); //communicates directly with the MocdalWindow.vue component
      });
    },

    // Run this before OR after each use of the modal window (use the same choice for every use of the modal window)
    //not used
    resetModalWindow() {
      eventBus.$emit("clearModalData"); //communicates directly with the ModalWindow.vue component
    },
  },
  created() {
    //Rec'd from App.vue
    eventBus.$on("inmatedatareceived", () => {
      this.$nextTick(() => {
        this.verifyDataExists();
        this.showLoadingButton = false;
        if (this.$store.state.AllowHistoricData) {
          this.AllowHistoricData = true;
        } else {
          document.getElementById("radio-is-historic").checked = false;
          document.getElementById("radio-is-current").checked = true;
        }
      });
    });
    //Rec'd from InmateBox.vue
    eventBus.$on("loadInmateBreakdown", () => {
      this.currentInmate = this.$store.state.inmate;
      this.showInmateBreakdown = true;
    });

    // eventBus.$on("historicdatareceived", () => {
    //   // console.log("Historic data received!");
    //   this.historicData = true;
    // });

    //Rec'd from App.vue
    eventBus.$on("dropdownsreceived", () => {
      // console.log(this.$store.state.dropDowns[0]);
      this.inmateStatuses = this.$store.state.dropDowns[0];
      this.inmateGenders = this.$store.state.dropDowns[1];
      this.inmateRaces = this.$store.state.dropDowns[2];
      // console.log(this.inmateGenders);
      // console.log(this.inmateRaces);
    });

    //Rec'd from App.vue
    eventBus.$on("historicsearchcomplete", () => {
      // this.filteredInmates = this.$store.state.historicResults;
      // console.log(this.$store.state.historicResults);
      if (this.$store.state.historicResults == "Too many results") {
        alert("Too many results found, please refine your search.");
      } else {
        this.historicInmates = this.$store.state.historicResults;
        this.filterInmateSearchResults(true);
      }

      this.displayLoader = false;
      this.showInmateBreakdown = false;
      this.showInmateResults = true;
    });

    //Rec'd from App.vue
    eventBus.$on("historicsearchfailed", () => {
      this.displayLoader = false;
    });
  },
  // mounted() {
  //   document.addEventListener("backbutton", this.returnToSearchResults, false);
  // },
  // beforeDestroy() {
  //   document.removeEventListener("backbutton", this.returnToSearchResults);
  // },
};
</script>

<style>
#search-field {
  color: black;
}

#search-field.breakdownView {
  margin-bottom: -40px;
}

#search-inputs {
  display: flex;
  flex-wrap: wrap;
  max-width: 100%;
  justify-content: center;
}

#search-inputs > * {
  margin: 20px 10px;
  max-width: 200px;
}

.entry-title {
  display: block;
  color: rgb(18, 27, 102);
}

button {
  margin: 0 8px 5px;
  background-color: rgb(18, 27, 102);
  border-radius: 5px;
  color: white;
  font-weight: bolder;
  width: 150px;
  height: 34px;
}

.btnDisabled {
  background-color: grey;
}

button:hover {
  /* background-color: rgba(18, 26, 102, 0.5); */
  cursor: pointer;
  background-color: rgb(68, 87, 152);
  /* color: rgb(18,27,102); */
}

#radio-current-historic {
  margin-bottom: 15px;
}

.inmate-full {
  display: flex;
  flex-wrap: wrap;
  width: 90%;
  justify-content: space-evenly;
  /* padding: 0 50px; */
  padding-left: 5%;

  /* margin-right: 10px; */
}

.text-entry > input {
  width: 200px;
  height: 18px;
  /* height: 25px; */
}

.select-list {
  color: black;
  height: 24px;
  width: 208px;
  margin-top: none;
  font-size: 24;
}

.inmate-back-button {
  font-size: 30px;
}

.inmate-back-button:hover {
  cursor: pointer;
}

.results {
  font-size: 28px;
  margin-top: 10px;
}

.results .break-line {
  width: 80%;
  left: 10%;
}

.results-count {
  font-size: 14px;
}

.inmate-breakdown button {
  margin-top: 10px;
}

.no-results {
  color: rgb(18, 27, 102);
  margin-top: 10%;
}

.next-prev-buttons {
  display: flex;
  justify-content: center;
}

.unfinished {
  color: grey !important;
}

.small-loader {
  height: 16px;
  padding: 0 2px;
  position: relative;
  top: 2px;
}

.back-button {
  margin-bottom: 14px;
}

.loader > img {
  height: 150px;
  margin-top: 150px;
}
</style>